import {useState} from 'react';

export default function TagInput({tags, onChange}) {
    const [draft, setDraft] = useState('');

    const addTag = () => {
        const tag = draft.trim().toLowerCase();
        if (tag && !tags.includes(tag)) onChange([...tags, tag]);
        setDraft('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            addTag();
        }
    };

    return (
        <div className="tag-input">
            {tags.map(tag => (
                <span key={tag} className="chip">
                    {tag}
                    <button type="button" onClick={() => onChange(tags.filter(t => t !== tag))}>×</button>
                </span>
            ))}
            <input
                value={draft}
                onChange={e => setDraft(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={addTag}
                placeholder="Ajouter un tag"
            />
        </div>
    );
}
